import React, { PropTypes } from 'react';
import classnames from 'classnames';
import EmailSubscriptionForm from 'landing_pages/components/email_subscription_form';
import EmailSubscriptionForm2 from 'landing_pages/components/email_subscription_form_2';
import { trackGoogle, trackFacebookCustomEvent } from 'common/tracking';

const trackSubscription = (action, label) => {
  trackGoogle("subscribed_email", action, label);
  trackFacebookCustomEvent("1726897664301628", "subscribed_email", {
    "where": "landing_hero",
    "label": label
  });
}

const SubscriptionHero = ({
  image, pretitle, title, subtitle, content_html, action_url, security_code, submit_label,
  promo, className, formTitle, formClassName, background, introAlignment='center',
  showSingleNameField, hideNameFields, notice, contentAlignment='center', intercomTag,
  pageUrlStem, successTitle, blockType
}) => {

  const Form = intercomTag? EmailSubscriptionForm2 : EmailSubscriptionForm;

  return (
    <section className={classnames('block block-subs-hero', className, background, {
      'without-image': !image
    })} id="subs_hero">

      <div className={`row intro-wrapper align-${introAlignment}`}>
        <div className={classnames("columns small-16 intro", { "large-10": !!image })}>
          {pretitle && <h3 className="pretitle">{ pretitle }</h3>}
          <h1 className="title">{ title }</h1>
          {subtitle && <h2 className="subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} />}
        </div>
      </div>

      { !!image &&
      <div className='row'>
        <div className="columns small-16 large-8 large-order-2">
          <div className="artwork-container">
            <img src={image.url} alt={image.alt}/>
          </div>
        </div>
        <div className="columns small-16 large-8 large-order-1">
          <div className="hero-content" dangerouslySetInnerHTML={{ __html: content_html }} />
        </div>
      </div> }

      <div className="subscribe-form">
        <div className="row form-row">
          <div className={classnames("columns small-16", { "large-6": !image })}>
            <Form
              align={!image? `align-${contentAlignment}` : undefined}
              action_url={action_url}
              security_code={security_code}
              submit_label={submit_label}
              callback={trackSubscription.bind(null, blockType, (intercomTag || title).toLowerCase())}
              promo={promo}
              className={formClassName}
              background={background}
              showSingleNameField={showSingleNameField}
              hideNameFields={hideNameFields}
              notice={notice}
              pageUrlStem={pageUrlStem}
              intercomTag={intercomTag}
              formTitle={formTitle}
              successTitle={successTitle}
            />
          </div>
          { !image &&
          <div className="columns small-16 large-offset-1 large-9 hero-content-wrapper">
            <div className="hero-content" dangerouslySetInnerHTML={{ __html: content_html }} />
          </div> }
        </div>
      </div>

    </section>
  );
}

SubscriptionHero.propTypes = {
  pretitle: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  content_html: PropTypes.string,
  image: PropTypes.object,
  className: PropTypes.string,
  formTitle: PropTypes.string,
  background: PropTypes.string,
  introAlignment: PropTypes.string,
  contentAlignment: PropTypes.string,
  notice: PropTypes.string,
  showSingleNameField: PropTypes.bool,
  hideNameFields: PropTypes.bool,
  intercomTag: PropTypes.string,
  pageUrlStem: PropTypes.string.isRequired,
  successTitle: PropTypes.string,
  blockType: PropTypes.string.isRequired,
};

export default SubscriptionHero;



// WEBPACK FOOTER //
// ./landing_pages/components/subscription_hero.jsx